<template>
  <div id="ResultsContainer">
    <div v-if="hours.length > 0" class="ContainerTimeSelector flex mt-3 flex-wrap md:p-4 br16">
      <div
        v-for="(hour, index) in hours"
        :key="index"
        @click="setActiveHour(hour.value)"
        :class="{ active: selectedHour == hour.value }"
        class="cursor-pointer h-12 rounded-lg flex justify-center items-center text-sm flex-shrink basis-1/4"
      >
        <div>
          {{ hour.label }}
        </div>
      </div>
    </div>
    <div v-else class="ContainerTimeSelector flex justify-center items-center mt-3 md:p-4 br16 error-message text-center w-full">
      <h5>{{ $t("search_no_resources_found") }}</h5>
    </div>
  </div>
</template>

<script lang="ts">
import { Hour } from '@/custom-models/hour';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'HoursSelector',
  emits: ['setActiveHour','noAvailableHours'],
  props: {
    hours: {
      type: Array as PropType<Hour[]>,
      required: true,
    },
    defaultHour:{
      type: String,
      required: false
    }
  },
  created(){
    if(this.defaultHour){
      this.selectedHour = this.defaultHour;
    }
  },
  data() {
    return {
      selectedHour:'',
    };
  },
  watch: {
    hours: {
      immediate: true,
      handler(newHours) {
        this.tryPreselectHour();
      }
    },
  },
  methods: {
    setActiveHour(hour:any) {
      if (this.selectedHour === hour) return;
      this.selectedHour = hour;
      this.$emit('setActiveHour', this.selectedHour);
    },
    tryPreselectHour() {
      if (!this.hours?.length) {
        this.$emit('noAvailableHours');
        return;
      }
      this.selectedHour = this.defaultHour && this.hours.some(h => h.value === this.defaultHour)
        ? this.defaultHour
        : this.hours[0].value;
      this.$emit('setActiveHour', this.selectedHour);
    }
  },
});
</script>
<style scoped>
#ResultsContainer{
  width: initial !important;
}
</style>
